import { render, staticRenderFns } from "./addOwnerMember.vue?vue&type=template&id=a4f15a2e&scoped=true"
import script from "./addOwnerMember.vue?vue&type=script&lang=js"
export * from "./addOwnerMember.vue?vue&type=script&lang=js"
import style0 from "./addOwnerMember.vue?vue&type=style&index=0&id=a4f15a2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f15a2e",
  null
  
)

export default component.exports